import {
  KoButton,
  KoDropdown,
  KoLoader,
  KoModal,
  KoStaicMembers,
  KoText,
  KoTitle,
  KoToast
} from "packages";
import KoIcon from "@kwapio/icons";
import styles from "../feed.module.scss";
import { FeedAPI } from "../feed.service";
import { useState } from "react";

function timeAgo(i) {
  if (!i) return "";
  const d = Math.floor((Date.now() - new Date(i).getTime()) / 1000);
  if (d < 60) return `${d}s`;
  if (d < 3600) return `${Math.floor(d / 60)}m`;
  if (d < 86400) return `${Math.floor(d / 3600)}h`;
  return `${Math.floor(d / 86400)}d`;
}

export default function FeedHeader({ post, user, getFeeds, onEditPost, isHideActions }) {

  const canDelete = post?.createdBy === user?.userId;
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const deletePost = () => {
    setLoading(true);
    FeedAPI.deleteFeed(post.feedId)
      .then(() => {
        setLoading(false);
        setDeleteModal(false);
        getFeeds && getFeeds();
        KoToast.success("Post deleted successfully");
      })
      .catch(() => setLoading(false));
  };

  return (
    <>
      {loading  && <KoLoader /> }
      <header className={styles.cardHeader}>
        <KoStaicMembers
          data={{
            firstName: post.author?.firstName,
            lastName: post.author?.lastName,
            logo: post.author?.logo
          }}
          feed={true}
          time={`${timeAgo(post.createdAt)} ago`}
        />

        {isHideActions && <KoDropdown
          overlayClassName={styles.settings}
          popupRender={() => (
            <div className={styles.customDropdown}>
              <div className={styles.customDropdownContnet}>
                <ul>
                  {canDelete && (<li onClick={() => onEditPost(post)}><KoIcon name="EditOutlined" /><KoText text="Edit" /></li>)}
                  {canDelete && (
                    <li onClick={() => setDeleteModal(true)}>
                      <KoIcon name="DeleteOutlined" /><KoText text="Delete" />
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}
          placement="bottomRight"
        >
          <KoButton
            type="text"
            icon={<KoIcon name="VerticalMenuOutlined" width={18} height={18} />}
            className={`${styles.btn} smallBtn ${styles.titleRightMore}`}
          />
        </KoDropdown>}
      </header>
      <KoModal
        title={`Delete Feed`}
        centered
        open={isOpenDelete}
        handleOk={() => {setDeleteModal(false); }}
        onClose={() => {setDeleteModal(false); }}
        width={580}
        // maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='delete' color="danger" variant="solid"  type='primary' label='Delete' onClick={() => deletePost()} />
        ]}
      >
        <div className={styles.delWrapper}>
          <KoTitle level={5} text={`This action will delete feed and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>
    </>
  );
}
